import { Compass } from "lucide-react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { EmptyState } from "../components/empty/EmptyState";

type LegacyRedirectType = "event" | "race" | "track";

type LegacyRedirectPageProps = {
  type: LegacyRedirectType;
};

const queryKeysByType: Record<LegacyRedirectType, string[]> = {
  event: ["id", "eventId"],
  race: ["id", "eventId"],
  track: ["id", "sessionId", "sid"]
};

const targetPathByType: Record<LegacyRedirectType, string> = {
  event: "/event",
  race: "/race",
  track: "/track"
};

function firstQueryValue(search: string, keys: string[]) {
  const params = new URLSearchParams(search);
  for (const key of keys) {
    const value = params.get(key)?.trim();
    if (value) return value;
  }
  return "";
}

export function buildLegacyRedirectTarget(type: LegacyRedirectType, search: string) {
  const id = firstQueryValue(search, queryKeysByType[type]);
  if (!id) return null;
  return `${targetPathByType[type]}/${encodeURIComponent(id)}`;
}

export function LegacyRedirectPage({ type }: LegacyRedirectPageProps) {
  const location = useLocation();
  const target = buildLegacyRedirectTarget(type, location.search);

  if (target) {
    return <Navigate replace to={target} />;
  }

  return (
    <section className="page">
      <EmptyState
        icon={Compass}
        title="Ο σύνδεσμος δεν είναι πλήρης ή δεν είναι πλέον διαθέσιμος."
        description="Άνοιξε την αρχική σελίδα ή τις δράσεις για να βρεις ξανά τη δράση."
      />
      <div className="quick-actions">
        <Link className="action-button primary" to="/">
          Dashboard
        </Link>
        <Link className="action-button ghost" to="/events">
          Δράσεις
        </Link>
      </div>
    </section>
  );
}
